/*eslint-disable */
import { PERM_DELETE_UNAPPROVED } from "../../../../../../../../store/Users/constants";
import { getPermission } from "../../../../../../../../store/Users/functions";

export const hidden = (status, user) => {
  if (!getPermission(PERM_DELETE_UNAPPROVED, user)) {
    return true;
  }
};
